<template>
  <v-dialog v-model="propDialogo" width="400px" persistent>
    <v-card style="padding: 15px">
      <v-icon class="ma-1 right top" style="position: absolute" color="#0D47A1" large
        @click="$emit('closeDialogo')">mdi-close-circle</v-icon>
      <div style="text-align: center; justify-content: center">
        <div class="ml-4 mr-4">
          <h1 style="line-height: 1.2; color: black; text-align: center">
            DETALLES DE SOLICITUD
          </h1>
        </div>
       <br>
       <h2>Fecha: <span style="font-weight: lighter;"> {{ propSolicitud.fecha_creacion }}</span></h2>
       <h2>Asunto: <span style="font-weight: lighter;"> {{ propSolicitud.asunto }}</span></h2>
       <h2>Nombre solicitante: <span style="font-weight: lighter;"> {{ propSolicitud.nombre }}</span></h2>
       <h2>Correo solicitante: <span style="font-weight: lighter;"> {{ propSolicitud.correo }}</span></h2>
       <h2>Celular solicitante: <span style="font-weight: lighter;"> {{ propSolicitud.celular }}</span></h2>
       <br>
       <h2>Mensaje</h2>
       <h3>
        <span style="font-weight: lighter;"> {{ propSolicitud.mensaje }}</span>
       </h3>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
components:{
},
  props: {
    propDialogo: { type: Boolean },
    propSolicitud: { type: Object }
  },
  data() {
    return {
    };
  },
  mounted() { },
  watch: {},
  methods: {
  },
};
</script>
<style scoped></style>
